export const storage = <T>(storageKey = '') => {
  const getItem = (defaultValue?: T, key = storageKey): T => {
    const item = sessionStorage.getItem(key)
    if (item) return JSON.parse(item) as T
    return defaultValue ?? ({} as T)
  }

  const setItem = (value: T, key = storageKey) => {
    sessionStorage.setItem(key, JSON.stringify(value))
  }

  const removeItem = (key = storageKey) => {
    sessionStorage.removeItem(key)
  }

  const state = (defaultValue: any, key = storageKey) => {
    return JSON.parse(sessionStorage.getItem(key) ?? '{}') ?? defaultValue
  }

  const setAndGetItem = (value: T, defaultValue: any, key = storageKey): T => {
    setItem(value, key)
    return getItem(defaultValue, key)
  }

  const clear = () => {
    sessionStorage.clear()
  }

  return {
    getItem,
    setItem,
    removeItem,
    state,
    setAndGetItem,
    clear,
  }
}
